import { getDocument, fetchDocuments } from 'services/documentService'
import { GET_DOCUMENT, FETCH_DOCUMENTS } from './actions.type'
import { base64ToArrayBuffer, createAndDownloadBlobFile } from 'services/downloadService'

const initialState = {
  documents: []
}

export const state = { ...initialState }

export const actions = {
  async [GET_DOCUMENT] (context, documentId) {
    const { data } = await getDocument(documentId)

    const arrayBuffer = base64ToArrayBuffer(data.file)

    createAndDownloadBlobFile(arrayBuffer, data.path)
  },

  async [FETCH_DOCUMENTS] (context) {
    let { data } = await fetchDocuments()

    data = data.map(v => {
      return {
        ...v,
        id: v.id ? v.id.toString() : undefined
      }
    })

    context.commit(FETCH_DOCUMENTS, data)
  }
}

export const mutations = {
  [FETCH_DOCUMENTS] (state, documents) {
    state.documents = documents
  }
}

const getters = {
  documents: state => state.documents
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/document.module.js